export const isEmail = (value, props) => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  let result = true
  const { contact } = props
  if (contact.value === 'e') {
    if (
      !!props.email &&
      (!props.email.value || !emailRegex.test(props.email.value))
    ) {
      result = false
    }
  }
  const message = result ? '' : 'Forneça um email válido'

  return { result, message }
}

export const isPhone = (value, props) => {
  let result = true

  if (!!props.phone && (!props.phone.value || props.phone.value.length < 9)) {
    result = false
  }

  const message = result ? '' : 'Forneça um número válido'

  return { result, message }
}

export const hasBillingAddress = (values, props) => {
  return (
    !!props &&
    !!props.billingAddress &&
    !!props.billingAddress.value &&
    props.billingAddress.value === 'd'
  )
}

export const required = (value) => {
  let message = `Campo de preenchimento obrigatório`
  if (!value || value === undefined) {
    return { result: false, message }
  }

  return { result: true, message: '' }
}

export const isNIF = (value) => {
  const message = 'NIF inválido'
  if (value.length < 9) return { result: false, message }
  const split = value.split('')
  const ident = split[0]
  if (ident === '0' && ident === '3' && ident === '4' && ident === '7')
    return { result: false, message }

  const total = split
    .slice(0, split.length - 1)
    .map((sp) => parseInt(sp, 10))
    .reduce(
      (sum, value, index, array) => sum + value * (array.length + 1 - index),
      0
    )

  const divided = 11 - (total % 11)
  const control = divided >= 10 ? 0 : divided

  const valid = control === parseInt(split[split.length - 1], 10)
  return { result: valid, message: valid ? '' : message }
}

export const notEmptyEmail = (value, refValue) => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const result = !value ? !!refValue : emailRegex.test(value)

  const message = result ? '' : 'Forneça um email válido'

  return { result, message }
}

export const notEmptyPhone = (value, refValue) => {
  const result = !value ? !!refValue : value.length === 9

  const message = result ? '' : 'Forneça um telefone válido'

  return { result, message }
}

export const isContactPhone = (values, props) => {
  return (
    !!props &&
    !!props.contact &&
    !!props.contact.value &&
    props.contact.value === 'p'
  )
}

export const isChecked = (value) => {
  let message = `Para aderir é necessario aceitar os termos.`
  if (value === false) {
    return { result: false, message }
  }

  return { result: true, message: '' }
}

export const hasPaidServices = (services) => {
  return services.some((srv) => srv.is_paid)
}



// WEBPACK FOOTER //
// ./src/components/JoinTariffModalV2/validations.js